module.exports = __webpack_public_path__ + "img/3_188.0f85f949.png";